// extracted by mini-css-extract-plugin
module.exports = {"header":"-GwdTtzmHMNx6-rDqd4SRA==","buttonWrapper":"rFcwShDyeTrIat5cvcTvNg==","createButton":"O5mFMDzbUOEi4VXIB-moOA==","text":"MjukVSCT2UMT1FpSUuOPrg=="};